import { render, staticRenderFns } from "./modifyAccount.vue?vue&type=template&id=b8000554&scoped=true"
import script from "./modifyAccount.vue?vue&type=script&lang=js"
export * from "./modifyAccount.vue?vue&type=script&lang=js"
import style0 from "./modifyAccount.vue?vue&type=style&index=0&id=b8000554&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8000554",
  null
  
)

export default component.exports